// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@conklin/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
        height: ${({ isCheckoutPage }: any) => (isCheckoutPage ? "42px" : "97px")};
        &,
        ${TypographyStyle} {
            line-height: 1;
        }

        ${xScreen("lte", "md")} {
            height: 48px;
        }
    `,
};

logoStyles.imgWrapper = {
    css: css`
        ${({ isCheckoutPage }: any) =>
            isCheckoutPage
                ? css`
                      width: 69px;
                      height: 42px;

                      img {
                          aspect-ratio: 69 / 42;
                      }
                  `
                : css`
                      width: 157px;
                      height: 97px;

                      img {
                          aspect-ratio: 157 / 97;
                      }
                  `}

        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }

        ${xScreen("lte", "md")} {
            width: 71px;
            height: 48px;

            img {
                aspect-ratio: 71 / 48;
            }
        }
    `,
};
